module.exports = __webpack_public_path__ + "static/media/PingFangHK Medium-01.93219aeb.svg";